module.exports = "//static.hsappstatic.net/LoginUI/static-1.14179/img/connect.com-full-logo-color.svg"